import { render, staticRenderFns } from "./ManageCustomerAccountDocumentCard.vue?vue&type=template&id=23efa927&scoped=true&"
import script from "./ManageCustomerAccountDocumentCard.vue?vue&type=script&lang=js&"
export * from "./ManageCustomerAccountDocumentCard.vue?vue&type=script&lang=js&"
import style0 from "./ManageCustomerAccountDocumentCard.vue?vue&type=style&index=0&id=23efa927&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23efa927",
  null
  
)

export default component.exports